import { memoizeFunction, mergeStyleSets, useTheme } from '@fluentui/react';
import { useScreen } from 'common/hooks/useScreen';
import { IAppTheme } from 'common/theme';
import { getBackdropFilterStyles } from 'common/utilities/BackdropFilterFallback';
import { useWebView } from 'store/webView/useWebView';
import { isWindows } from 'store/webView/webViewHelpers';

const getDialogCardFooterStyles = memoizeFunction(
  (theme: IAppTheme, isShortScreen: boolean, hasFooterBackground?: boolean, sticky?: boolean, isWindowsWebView?: boolean) => {
    const stickyStyles = {
      position: isShortScreen ? 'relative' : 'sticky',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 3,
    };

    const windowsWebViewStyles = {
      borderBottomLeftRadius: 8,
      borderBottomRightRadius: 8,
    };

    return mergeStyleSets({
      footer: {
        background: hasFooterBackground ? theme.appColors?.dialogFooterBackground : undefined,
        ...(hasFooterBackground ? getBackdropFilterStyles(theme, '20px') : {}),
        ...(sticky ? stickyStyles : {}),
        ...(isWindowsWebView ? windowsWebViewStyles : {}),
        paddingTop: 24,
        paddingBottom: 24,
      },
    });
  }
);

export const useDialogCardFooterStyles = (hasFooterBackground?: boolean, sticky?: boolean) => {
  const theme = useTheme() as IAppTheme;
  const { isShortScreen } = useScreen();
  const { isWebView, webViewPlatform } = useWebView();
  const isWindowsWebView = isWebView && isWindows(webViewPlatform);
  return getDialogCardFooterStyles(theme, isShortScreen, hasFooterBackground, sticky, isWindowsWebView);
};
